module.exports = __webpack_public_path__ + "static/media/il.5751148f.svg";